<!--  -->
<template>
  <div class="tab_box">
    <div class="selectr_box">
      <div class="select_small search_box">
        <el-input v-model="timepushlistquery.task_name" placeholder="请输入任务" style="width:230px" />
        <el-input v-model="timepushlistquery.relation_id" placeholder="请输入消息ID" style="width:230px;" />
        <el-select v-model="timepushlistquery.platform_id" filterable placeholder="请选择平台">
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="timepushlistquery.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>
      <div style="text-align: right">
        <el-button type="success" icon="el-icon-plus" @click="addtimingw">新增定时推送</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="taskName"
        label="任务名称"
        width="170"
      />
      <el-table-column
        align="center"
        prop="platformName"
        label="平台"
        width="80"
      />
      <el-table-column
        align="center"
        prop="tagGroupNames"
        label="标签"
        width="110"
      />
      <el-table-column
        align="center"
        prop="tagGroupNames"
        label="消息类型"
        width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.relationTypeText }}({{ scope.row.relationId }})
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sendTimeText"
        label="发送时间"
        width="155"
      />
      <el-table-column
        align="center"
        prop="userTotal"
        label="用户总数"
        width="80"
      />
      <el-table-column
        prop="created_at_text"
        label="发送群体"
        width="330"
        align="center"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.userWheresText" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="successTotal"
        label="发送成功用户数量"
        width="80"
      />
      <el-table-column
        align="center"
        prop="statusText"
        width="100"
        label="状态"
      >
        <template slot-scope="scope">
          <!-- <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.status == 2" class="el-icon-warning stopew" />
          <i v-if="scope.row.status == 3" class="el-icon-success defaultrse" />
          <i v-if="scope.row.status == 4" class="el-icon-success fasrw" />
          <i v-if="scope.row.status == 5" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 6" class="el-icon-error stopew" /> -->
          <i v-if="scope.row.status == 1" class="el-icon-warning" />
          <i v-if="scope.row.status == 2" class="el-icon-more-outline defaultrse" />
          <i v-if="scope.row.status == 3" class="el-icon-success defaultr" />
          <i v-if="scope.row.status == 4" class="el-icon-error stopew" />
          {{ scope.row.statusText }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="accountNames"
        label="发送的公众号"
      /> -->
      <el-table-column
        align="center"
        prop="realName"
        width="80"
        label="创建人"
      />
      <el-table-column
        align="center"
        prop="createdAtText"
        width="155"
        label="创建时间"
      />

      <el-table-column
        align="center"
        prop="tagGroupName"
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.showStopButton === 1" type="danger" size="mini" @click="tingyong(scope.row)">停止推送</el-button>
          <el-button type="primary" size="mini" style="margin-top:10px" @click="lookaccount(scope.row)">查看公众号</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="查看公众号列表"
      :visible.sync="accoutlistview"
      :destroy-on-close="true"
    >
      <accoutlist ref="accoutlistbox" />
    </el-dialog>
    <pagination-right
      :current-page="timepushlistquery.page"
      :total="tableDatatotal"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { timingpushlist, stoppush, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import accoutlist from './components/accoutlist.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    accoutlist
  },
  mixins: [convertToHump],
  data() {
    return {
      timepushlistquery: {
        page: 1,
        pageSize: 10,
        task_name: '',
        relation_id: '',
        platform_id: null,
        onlyMe: 2
      },
      accoutarr: [],
      tableData: [],
      accountarr: [{
        value: 1,
        label: '查看组内推送'
      }, {
        value: 2,
        label: '我创建的推送'
      }],
      tableDatatotal: null,
      accoutlistview: false
    }
  },
  activated() {
    this.gettimepushlist()
  },
  created() {
    this.gettimepushlist()
    this.getstrategyplatform()
  },
  mounted() {

  },
  methods: {
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    async gettimepushlist() {
      const data = await timingpushlist(this.timepushlistquery)
      this.tableData = this.convertToHump(data.data.list)
      this.tableDatatotal = data.data.total
      console.log('data', data)
    },
    search() {
      this.timepushlistquery.page = 1
      this.gettimepushlist()
    },
    reast() {
      this.timepushlistquery = {
        page: 1,
        pageSize: 10,
        task_name: '',
        relation_id: '',
        platform_id: null,
        onlyMe: 2
      }
      this.gettimepushlist()
    },
    fetchPageSizeone(e) {
      this.timepushlistquery.pageSize = e
      this.gettimepushlist()
    },
    fetchCurrentPageone(e) {
      this.timepushlistquery.page = e
      this.gettimepushlist()
    },
    async tingyong(item) {
      this.$confirm('确定要停止推送吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        stoppush({ task_no: item.taskNo }).then((data) => {
          if (data.code === 200) {
            this.$message({
              message: '停用成功',
              type: 'success'
            })
            this.gettimepushlist()
          }
        })
      })
    },
    lookaccount(item) {
      console.log(item)
      this.accoutlistview = true
      this.$nextTick(() => {
        this.$refs.accoutlistbox.send(item.taskNo)
      })
    },
    addtimingw() {
      this.$router.push({
        path: '/timedPush/index'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tab_box{
  padding: 30px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.selectr_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
.select_small{
  display: flex;
  align-items: center;
}
</style>
